import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ProjectMode, ProjectType } from '../../../utils/enums';
import { RouteUrls } from '../../../configs/routeUrls';

export class HighlightProject extends Component {
	constructor(props) {
		super(props);
		this.getProjectTypeSettings = (
			type,
			isAuth = false,
			availableVoteNotLogged = false,
			isLegalAgeUser = false,
			isUserCitizen = false,
			onlyForLegalAge = false,
			mode = ProjectMode.NotSetted
		) => {
			switch (type) {
				case ProjectType.Consultation:
					return {
						url:
							mode === ProjectMode.Open ||
								(mode !== ProjectMode.Open && (onlyForLegalAge ? isAuth && isLegalAgeUser : isAuth))
								? RouteUrls.Consultation.voteFunc(this.props.id)
								: RouteUrls.Consultation.previewFunc(this.props.id),
						name: 'Konsultacja',
						colorClass: 'bag--primary'
					};
				case ProjectType.Survey:
					return {
						url:
							mode === ProjectMode.Open ||
								(mode !== ProjectMode.Open && (onlyForLegalAge ? isAuth && isLegalAgeUser : isAuth))
								? RouteUrls.Survey.voteFunc(this.props.id)
								: RouteUrls.Survey.previewFunc(this.props.id),
						name: 'Ankieta',
						colorClass: 'bag--secondary'
					};
				case ProjectType.PublicBudget:
					return {
						url:
							(availableVoteNotLogged && !isAuth) ||
								(mode === ProjectMode.Citizen &&
									(onlyForLegalAge ? isAuth && isLegalAgeUser && isUserCitizen : isAuth && isUserCitizen))
								? RouteUrls.Budget.vote.voteFunc(this.props.budgetYear, this.props.id)
								: RouteUrls.Budget.vote.previewFunc(this.props.budgetYear, this.props.id),
						name: 'Budżet',
						colorClass: 'bag--danger'
					};
				default:
					return {
						url: '',
						name: '',
						colorClass: ''
					};
			}
		};
	}

	render() {
		const {
			isAuth,
			availableVoteNotLogged = false,
			isLegalAgeUser = false,
			isUserCitizen = false,
			onlyForLegalAge = false,
			mode = ProjectMode.NotSetted
		} = this.props;
		let { url, name, colorClass } = this.getProjectTypeSettings(
			this.props.type,
			isAuth,
			availableVoteNotLogged,
			isLegalAgeUser,
			isUserCitizen,
			onlyForLegalAge,
			mode
		);

		return (
			<Link className="cases__case" to={url} title={`Przejdź do strony z projektem ${this.props.title}`}>
				<i className="fa fa-chevron-right cases__arrow" aria-hidden="true" />
				<span className="cases__text cases__text--primary-dark" aria-hidden="true">
					{this.props.title}
				</span>
			</Link>
		);
	}
}
